import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';
import Topo from '../Layout/Topo';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';
class AircraftLogbookReset extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      aircraft_id: null,
      aircrafts_list: [],
      engines_list: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.reset = this.reset.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  validateFlightHours(value, event) {
    const hourPattern = /^\d{1,6}:[0-5][0-9]$/; // Atualizado para nova especificação
    if (!hourPattern.test(value) && value !== '' && value !== null && value !== undefined) {
      this.setState({overlay: {message: 'Os campos de horas devem estar no formato HH:MM, com até 6 dígitos para as horas e minutos entre 00 e 59.', type: 'error', status: 'open'}});
      return false;
    }
    return true;
  }
  
  handleSelectChangeAircraft(name, event) {
    var change = {};
    console.log(event);
    if(event == null) {
      change[name] = null;
      change['engines_list'] = null;
      this.setState(change);
      return;
    }

    var self = this;
    var header = this.refs.request_api.header('application/json');
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/aeronave/diario/selecionar/'+event.value;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if(responseJson.status === 'success') {
          self.setState({ engines_list: responseJson.data.engines_list });
          self.setState({ aircraft_initial_flight_hours: responseJson.data.aircraft.initial_flight_hours_str });
          self.setState({ initial_landings: responseJson.data.aircraft.initial_landings });
          self.setState({ logbook_date_open: responseJson.data.aircraft.logbook_date_open_str });
          self.setState({ engine_1_id: responseJson.data.aircraft.engine_1_id });
          self.setState({ engine_1_actual: responseJson.data.engine_1_actual });
          self.setState({ engine_1_initial: responseJson.data.engine_1_initial });
          self.setState({ engine_2_id: responseJson.data.aircraft.engine_2_id });
          self.setState({ engine_2_actual: responseJson.data.engine_2_actual });
          self.setState({ engine_2_initial: responseJson.data.engine_2_initial });
        }
        self.setState({ aircraft_id: event.value });
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      });
    });
  }
  
  handleSelectChangeEngine(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
      this.setState(change);
      return;
    }

    change[name] = event.value;
    this.handleAlert('', '', 'open');
    var datasave = {
      aircraft_id: this.state.aircraft_id,
      engine_id: event.value,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/aeronave/motor/selecionar';
      fetch(url, { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if(responseJson.status === 'success') {
          self.setState({ engine_1_initial: responseJson.data.initial_flight_hours_str });
          self.setState({ engine_1_actual: responseJson.data.actual_flight_hours_str })
          self.setState(change);
        } 
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).then(() => {
        console.log();
      });
    });

  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/aeronaves/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({ aircrafts_list: responseJson.data });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      });
    });
  }

  reset(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      logbook_date_open: this.state.logbook_date_open,
      aircraft_initial_flight_hours: this.state.aircraft_initial_flight_hours,
      initial_landings: this.state.initial_landings,
      engine_1_id: this.state.engine_1_id,
      engine_1_initial: this.state.engine_1_initial,
      engine_1_actual: this.state.engine_1_actual,
      engine_2_id: this.state.engine_2_id,
      engine_2_initial: this.state.engine_2_initial,
      engine_2_actual: this.state.engine_2_actual,
      aircraft_id: this.state.aircraft_id,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/aeronave/diario/reset', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo />
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title pull-left">Resetar diário de bordo</h3>
      <Link to="/aeronave/diarios" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.reset}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Aeronave:</label>
              <Select
                className="form-field-name"
                name="aircraft_id"
                value={this.state.aircraft_id}
                searchable={true}
                placeholder={'Selecionar matrícula de aeronave'}
                onChange={this.handleSelectChangeAircraft.bind(this, 'aircraft_id')}
                options={this.state.aircrafts_list}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Data de abertura do Logbook:</label>
              <br/>
              <InputMask value={this.state.logbook_date_open}  maskChar={null} name="logbook_date_open" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'logbook_date_open')} placeholder={this.locale.general.diaMesAno} required/>
            </div>
          </div>
        </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                    <label>Horas Iniciais:</label>
                    <input
                    type="text"
                    name="aircraft_initial_flight_hours"
                    className="form-control"
                    value={this.state.aircraft_initial_flight_hours}
                    onChange={this.handleChange.bind(this, 'aircraft_initial_flight_hours')}
                    onBlur={this.validateFlightHours.bind(this, this.state.aircraft_initial_flight_hours)}
                    placeholder="00000:00"
                    required
                    />
                </div>
              </div>
              <div className="col-md-6">
              <div className="form-group">
                  <label>Pousos Iniciais:</label>
                  <input type="number" value={this.state.initial_landings} name="initial_landings" mask="99999:99" className="form-control" onChange={this.handleChange.bind(this, 'initial_landings')} placeholder="0" required />
              </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                  <div className="form-group">
                    <label>Engine #1:</label>
                    <Select
                        className="form-field-name"
                        name="engine_1_id"
                        value={this.state.engine_1_id}
                        searchable={true}
                        placeholder='Select'
                        onChange={this.handleSelectChangeEngine.bind(this, 'engine_1_id')}
                        options={this.state.engines_list}
                        required={true}
                    />
                  </div>
              </div>
              <div className="col-md-4">
                  <div className="form-group">
                    <label>{'Horas iniciais do motor'}:</label>
                    <input
                        type="text"
                        name="engine_1_initial"
                        className="form-control"
                        value={this.state.engine_1_initial}
                        onChange={this.handleChange.bind(this, 'engine_1_initial')}
                        onBlur={this.validateFlightHours.bind(this, this.state.engine_1_initial)}
                        placeholder="00000:00"
                        required
                    />
                  </div>
              </div>
              <div className="col-md-4">
                  <div className="form-group">
                    <label>{'Horas atuais do motor'}:</label>
                    <input
                        type="text"
                        name="engine_1_actual"
                        className="form-control"
                        value={this.state.engine_1_actual}
                        onChange={this.handleChange.bind(this, 'engine_1_actual')}
                        onBlur={this.validateFlightHours.bind(this, this.state.engine_1_actual)}
                        placeholder="00000:00"
                        required
                    />
                  </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                  <div className="form-group">
                    <label>Engine #2:</label>
                    <Select
                        className="form-field-name"
                        name="engine_2_id"
                        value={this.state.engine_2_id}
                        searchable={true}
                        placeholder='Select'
                        onChange={this.handleSelectChangeEngine.bind(this, 'engine_2_id')}
                        options={this.state.engines_list}
                        required={true}
                    />
                  </div>
              </div>
              <div className="col-md-4">
                  <div className="form-group">
                    <label>{'Horas iniciais do motor'}:</label>
                    <input
                        type="text"
                        name="engine_2_initial"
                        className="form-control"
                        value={this.state.engine_2_initial}
                        onChange={this.handleChange.bind(this, 'engine_2_initial')}
                        onBlur={this.validateFlightHours.bind(this, this.state.engine_2_initial)}
                        placeholder="00000:00"
                        required
                    />
                  </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>{'Horas atuais do motor'}:</label>
                  <input
                      type="text"
                      name="engine_2_actual"
                      className="form-control"
                      value={this.state.engine_2_actual}
                      onChange={this.handleChange.bind(this, 'engine_2_actual')}
                      onBlur={this.validateFlightHours.bind(this, this.state.engine_2_actual)}
                      placeholder="00000:00"
                      required
                  />
                </div>
              </div>
            </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Resetar diários de bordo</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default AircraftLogbookReset;


// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/AircraftLogbookReset.js